/* eslint-disable no-nested-ternary */
import { formatWithSymbolAndSeparator } from 'mr-components';
import { roundOff, roundTo2, roundTo2String } from './float';

export function calculateDiscountValue({ price, offerPrice, discountType }) {
  const discount = roundTo2(price - offerPrice);

  let discountDisplayValue = 0;
  if (discountType === 'percentage') {
    discountDisplayValue = (discount / price) * 100;
    discountDisplayValue = roundTo2(discountDisplayValue);
  } else {
    discountDisplayValue = roundTo2(discount);
  }
  return discountDisplayValue;
}

export function getDiscountDisplay({
  discount,
  discountValue,
  discountType,
  currencyFormat,
  currencySymbol,
  productDiscountText,
}) {
  let discountDisplay = productDiscountText.replace(
    '{{discount}}',
    currencyFormat
      .replace('{{amount}}', roundTo2String(discount))
      .replace('{{currencySymbol}}', currencySymbol),
  );

  if (discountType === 'percentage') {
    discountDisplay = productDiscountText.replace(
      '{{discount}}',
      `${roundTo2String(discountValue)}%`,
    );
  }
  return discountDisplay;
}

export function getAmountDisplay({
  currencyFormat,
  currencySymbol,
  amount,
  decimalSymbol = '.',
  thousandSeparator = ',',
}) {
  return currencyFormat
    .replace(
      '{{amount}}',
      formatWithSymbolAndSeparator({
        val: roundTo2String(amount),
        decimalSymbol,
        thousandSeparator,
      }),
    )
    .replace('{{currencySymbol}}', currencySymbol);
}

export function calculateDiscount({
  price,
  compareAtPrice,
  offText,
  taxes = 0,
  shipping = 0,
  discountValue = 0,
  isDiscountDisabled = false,
  discountType,
  currencyFormat,
  decimalSymbol,
  thousandSeparator,
  productDiscountText,
  currencySymbol,
  isApplyDiscountOnCompareAtPrice,
  priceRoundType = 'none',
  discountRoundType = 'none',
}) {
  let priceForCalculation = parseFloat(price);
  const compareAtPriceFloat = parseFloat(compareAtPrice);

  if (isApplyDiscountOnCompareAtPrice && compareAtPriceFloat > price) {
    priceForCalculation = parseFloat(compareAtPrice);
  }

  let discount = 0;
  if (isDiscountDisabled) {
    // eslint-disable-next-line no-param-reassign
    discountValue = 0;
  }
  let discountDisplayValue = discountValue;
  if (discountType === 'percentage') {
    discount = priceForCalculation * 1.0 * (discountValue / 100.0);
  } else if (discountType === 'fixed') {
    discount = priceForCalculation - discountValue;
  } else {
    discount = discountValue;
  }

  let offerPriceFloat = roundTo2(priceForCalculation) - roundTo2(discount);

  // case where discount is less than the actual discount
  if (offerPriceFloat > price && isApplyDiscountOnCompareAtPrice) {
    offerPriceFloat = price;
    discount = roundTo2(compareAtPrice - price);
    discountDisplayValue = calculateDiscountValue({
      price: compareAtPrice,
      offerPrice: offerPriceFloat,
      discountType,
    });
  }

  // rounding price by user input
  offerPriceFloat = roundOff(offerPriceFloat, priceRoundType);
  // rounding discount by user input
  discount = roundOff(discount, discountRoundType);
  discountDisplayValue = roundOff(discountDisplayValue, discountRoundType);

  const priceDisplay = getAmountDisplay({
    currencyFormat,
    currencySymbol,
    amount: priceForCalculation,
    decimalSymbol,
    thousandSeparator,
  });

  const offerPriceDisplay = getAmountDisplay({
    currencyFormat,
    currencySymbol,
    amount: offerPriceFloat,
    decimalSymbol,
    thousandSeparator,
  });

  let discountDisplay = productDiscountText.replace(
    '{{discount}}',
    currencyFormat
      .replace('{{amount}}', roundTo2String(discount))
      .replace('{{currencySymbol}}', currencySymbol),
  );

  if (discountType === 'percentage') {
    discountDisplay = productDiscountText.replace(
      '{{discount}}',
      `${roundTo2String(discountDisplayValue)}%`,
    );
  }

  const taxesDisplay =
    taxes > 0
      ? currencyFormat.replace('{{amount}}', roundTo2String(taxes))
      : 'Free';
  const shippingDisplay =
    shipping > 0
      ? currencyFormat.replace('{{amount}}', roundTo2String(shipping))
      : 'Free';

  const totalWithTaxesAndShipping = getAmountDisplay({
    currencyFormat,
    currencySymbol,
    amount:
      roundTo2(priceForCalculation) -
      roundTo2(discount) +
      roundTo2(taxes) +
      roundTo2(shipping),
    decimalSymbol,
    thousandSeparator,
  });

  return {
    price: priceDisplay,
    priceFloat: roundTo2(priceForCalculation),
    offer_price: offerPriceDisplay,
    offerPriceFloat,
    discount: discountDisplay,
    discountFloat: roundTo2(discount),
    displayDiscount: discount > 0,
    taxes: taxesDisplay,
    shipping: shippingDisplay,
    totalWithTaxesAndShipping,
  };
}
